/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  UserFlagsModeratorControllerDeleteMutationResponse,
  UserFlagsModeratorControllerDeletePathParams,
  UserFlagsModeratorControllerDelete401,
} from '../types/UserFlagsModeratorControllerDelete.ts';

function getUserFlagsModeratorDeleteUrl(id: UserFlagsModeratorControllerDeletePathParams['id']) {
  const res = { method: 'DELETE', url: `/api/moderator/user-flags/${id}` as const };
  return res;
}

/**
 * {@link /api/moderator/user-flags/:id}
 */
export async function userFlagsModeratorDelete(
  id: UserFlagsModeratorControllerDeletePathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    UserFlagsModeratorControllerDeleteMutationResponse,
    ResponseErrorConfig<UserFlagsModeratorControllerDelete401>,
    unknown
  >({ method: 'DELETE', url: getUserFlagsModeratorDeleteUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
